import { useTranslation } from 'react-i18next';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui-kit/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui-kit/table';
import { PerformanceDashboard, ReviewerGroupScore } from '../../types/dashboard.types';

export interface ComparisonTableProps {
  dashboard: PerformanceDashboard;
}

export const ComparisonTable = ({ dashboard }: ComparisonTableProps) => {
  const { t } = useTranslation();

  if (!dashboard.ReviewerGroupScoresJson) return null;

  let groups: ReviewerGroupScore[] = [];
  try {
    groups = JSON.parse(dashboard.ReviewerGroupScoresJson) as ReviewerGroupScore[];
  } catch {
    groups = [];
  }

  if (groups.length === 0) return null;

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('REVIEWER_COMPARISON')}</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>{t('REVIEWER_GROUP')}</TableHead>
              <TableHead>{t('WEIGHTED_AVERAGE')}</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {groups.map((group) => (
              <TableRow key={group.ReviewerGroup}>
                <TableCell>{group.ReviewerGroup}</TableCell>
                <TableCell>{group.WeightedAverage.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
